import React from "react";
import { withStyles } from "@material-ui/core";
import ChooseLocationInput from "../components/ChooseLocationInput";
import api from "../utils/api";
import { getOfficeId, setOfficeId } from "../utils/preferences";
import { selectedOfficeIdChanged } from "./MainMenu";

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  }
};

class MainContent extends React.Component {
  state = {};
  componentDidMount() {
    api.valueList
      .get("OfficeId")
      .then(({ data }) => this.setState({ items: data }));
    // Load from localstore, because location should sustain per device
    this.setState({ value: getOfficeId() });
  }
  handleChange = e => {
    const value = e.target.value;
    this.setState({ value });
    setOfficeId(value);
    selectedOfficeIdChanged(value);
    // Refresh page so AppBar will be remounted and the new office id will be set
    window.location.reload();
  };
  render() {
    const { items, value } = this.state;
    if (!items) return null;
    const { classes } = this.props;
    return (
      <form className={classes.container} noValidate autoComplete="off">
        <ChooseLocationInput
          items={items}
          onChange={this.handleChange}
          value={value || ""}
        />
      </form>
    );
  }
}

// @ts-ignore
const ChooseLocation = withStyles(styles)(MainContent);
export default ChooseLocation;
